import {makeStyles} from '@material-ui/core'

const useStyles = makeStyles(theme => ({
  buttonLink: {
    textTransform: 'none',
  },
  paper: {
    width: 250,
    padding: 16,
    maxHeight: 350,
    overflow: 'auto',
    overflowY: 'auto',
  },
  toggleBtnStyle: {
    textTransform: 'none',
    width: 110,
    height: 35,
  },
  labelTransform: {
    transform: `translate(14px, 12px) scale(1)`,
  },
  paperTable: {
    width: '100%',
    marginBottom: theme.spacing(2),
    maxHeight: 250,
    maxWidth: 250,
  },
  table: {
    minWidth: 200,
    tableLayout: 'fixed',
  },
}))

export default useStyles
